import { createBrowserRouter, Navigate } from "react-router-dom";
import type { RouteObject } from "react-router-dom";
import routes from "./routes";
import ConditionalRoute from "@/components/ConditionalRoute/ConditionalRoute";
import PreLogin from "@/layouts/PreLogin/PreLogin";
import PostLogin from "@/layouts/PostLogin/PostLogin";
import PageNotFound from "@/pages/PageNotFound/PageNotFound";

export interface RouteConfig {
  path: string;
  element?: React.ReactNode; // make optional
  children?: Record<string, RouteConfig> | RouteConfig[];
  pageName?: string;
  sidebar?: { show: boolean };
  permissionName?: string;
  
}

const buildRoutes = (
  routesInput: Record<string, RouteConfig> | RouteConfig[]
): RouteObject[] => {
  const routesArray: RouteConfig[] = Array.isArray(routesInput)
    ? routesInput
    : Object.values(routesInput);

  return routesArray.map(({ path, element, children }) => ({
    path,
    ...(element ? { element } : {}), // only include element if it exists
    ...(children ? { children: buildRoutes(children) } : {}),
  }));
};


const router = createBrowserRouter([
  // Redirect root to login
  {
    path: "/",
    element: (
      <Navigate
        to={routes?.publicRoutes ? routes.publicRoutes.LOGIN.path : "/"}
        replace
      />
    ),
  },

  // Public routes
  {
    path: "/",
    element: <ConditionalRoute component={PreLogin} />,
    children: [
      {
        index: true,
        element: (
          <Navigate
            to={routes?.publicRoutes ? routes.publicRoutes.LOGIN.path : "/"}
          />
        ),
      },
      ...buildRoutes(routes.publicRoutes),
    ],
  },

  // Private routes
  {
    path: "/",
    element: <ConditionalRoute isPrivate component={PostLogin} />,
    children: [
      ...buildRoutes(routes.privateRoutes),
      {
        index: true,
        element: <Navigate to={routes.privateRoutes.DASHBOARD.path} />,
      },
    ],
  },

  // Catch-all
  {
    path: "*",
    element: <PageNotFound />,
  },
]);

export default router;
